export default "__VITE_ASSET__1d2b4bfc__"